import { ConveyorBeltTheme, styles, variants } from '../ConveyorBeltStyles.css';
import { multiVariantStyles } from './ConveyorBeltVariants.css';
import { baseTheme } from './ConveyorBeltBaseTheme.css';

const ConveyorBeltRedwoodTheme: ConveyorBeltTheme = {
  multiVariantStyles,
  baseTheme,
  variants,
  styles
};

export { ConveyorBeltRedwoodTheme };
